
import { SwappableCard } from "../SwappableCard";
import { WidgetResizeControl } from "./WidgetResizeControl";
import React, { useEffect } from "react";

interface ResizableSwappableCardProps {
  id: string;
  size: 'small' | 'medium' | 'large' | 'xlarge';
  showHandle: boolean;
  showResizeControl: boolean;
  onResize?: (newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
  onRemove?: (id: string) => void;
  className?: string;
  children: React.ReactNode;
}

export function ResizableSwappableCard({
  id,
  size,
  showHandle,
  showResizeControl,
  onResize,
  onRemove,
  className = "",
  children
}: ResizableSwappableCardProps) {
  // Add debugging for size changes
  useEffect(() => {
    console.log(`ResizableSwappableCard ${id} size:`, size);
  }, [id, size]);

  return (
    <div className="relative">
      <SwappableCard 
        id={id}
        showHandle={showHandle}
        onRemove={onRemove}
        className={className}
      >
        {children}
      </SwappableCard>
      
      {showResizeControl && onResize && (
        <WidgetResizeControl 
          currentSize={size}
          onResize={(newSize) => {
            console.log(`WidgetResizeControl for ${id} called with size:`, newSize);
            onResize(newSize);
          }}
        />
      )}
    </div>
  );
}
